import React, { PureComponent } from 'react';
import ReactDom from 'react-dom';

import { connect } from 'react-redux';
import CalIcon from '@material-ui/icons/Event';
import { CircularProgress } from 'material-ui/Progress';
import Tooltip from 'material-ui/Tooltip';

import Session from '../components/Session/DesignerSession';
import EmptyState from '../../common/EmptyState';
import * as DesignerState from '../../../state/reducer/designer/designer';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';
import Console from '../../../lib/debug';

class SessionDesigner extends PureComponent {
    componentDidMount() {
        // eslint-disable-next-line
        let node = ReactDom.findDOMNode(this);
        node.scrollTop =
            this.scrollTop + (node.scrollHeight - this.scrollHeight);
        if (this.props.designerScrollKey) {
            // eslint-disable-next-line
            node = ReactDom.findDOMNode(
                // eslint-disable-next-line
                this.refs['session-' + this.props.designerScrollKey]
            );
            if (!node) return;
            let y = node.getBoundingClientRect().top - 148;
            if (y < 0) y = 0;
            window.scrollTo(0, y);
        }
    }

    addNotes() {
        let day = this.props.day;
        let dispatch = this.props.dispatch;

        DesignerState.createSessionWithNotes(dispatch, day);
    }

    callback(event, type) {
        let day = this.props.day;
        let dispatch = this.props.dispatch;

        if (type) {
            DesignerState.createSessionWithBlock(dispatch, day, type);
        } else {
            DesignerState.createSession(day);
        }

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Add New Session'
        });
    }

    render() {
        Console.render('DesignerComponents');

        if (this.props.appMessage === 'Loading Sessions...') {
            const classes =
                'designer-palette layout-row layout-align-center-center';
            return (
                <div className={classes}>
                    <CircularProgress />
                </div>
            );
        }

        let day = this.props.day;
        let dayId = this.props.dayId;
        let dispatch = this.props.dispatch;
        let isPubEnabled = this.props.isPubEnabled;
        let isProgram = this.props.isProgram;

        let sessions = [];
        let sessionsWithButton = [];
        if (day) {
            for (let i = 0; i < day.items.length; i++) {
                let sessionId = day.items[i];
                sessions.push(
                    <Session
                        key={dayId + sessionId}
                        day={day}
                        ref={'session-' + sessionId}
                        sessionId={sessionId}
                        dispatch={dispatch}
                        isPubEnabled={isPubEnabled}
                        isProgram={isProgram}
                    />
                );
            }
        }

        let tooltip =
            "You can break an athlete's work into multiple training sessions";
        const paletteClasses =
            'designer-palette ' +
            'layout-row layout-align-space-between-center visible';
        let dayPalette = (
            <div className={paletteClasses}>
                <div
                    className={`palette-button session-button${
                        sessions.length ? '' : ' empty-day'
                    }`}
                    onClick={e => this.callback(e)}
                >
                    Add New Session
                </div>
            </div>
        );

        let emptyState = null;
        if (sessions.length === 0) {
            emptyState = (
                <div className="page-empty">
                    <EmptyState
                        icon={<CalIcon style={{ height: 124, width: 124 }} />}
                    >
                        {dayPalette}
                    </EmptyState>
                </div>
            );
        } else {
            sessionsWithButton = (
                <div>
                    {sessions}
                    {dayPalette}
                </div>
            );
        }

        return (
            <div>
                {emptyState}
                {sessionsWithButton}
            </div>
        );
    }
}

const mapDesignerStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        day: state.calendar.dayTree[ownProps.dayId],
        pageTitle: state.calendar.uiTree.pageTitle,
        isPubEnabled: state.calendar.uiTree.isPubEnabled,
        publishTime: state.calendar.uiTree.publishTime,
        programTitle: state.calendar.infoTree.team.title,
        programLogo: state.calendar.infoTree.team.logo,
        designerScrollKey: state.calendar.uiTree.designerScrollKey,
        appMessage: state.app.appMessage
    };
};

SessionDesigner = connect(mapDesignerStateToProps)(SessionDesigner);
export default SessionDesigner;



// WEBPACK FOOTER //
// ./src/view/designer/designer-base/DesignerComponents.jsx